
import CancelIcon from '@mui/icons-material/Cancel';
import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Container,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography
} from '@mui/material';
import { UserRole } from 'interfaces/config';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useUserStore } from 'state';
import { InputWrapper } from '../../../common';
import { useTableStore } from '../../../state/TableStore';
import { EditUserAction } from '../helpers';
import { useUserManagementStore } from '../state';
import { AddUserOriRfp } from "./AddUserOriRfp";

const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

export const EditUserDrawerContent: React.FC<any> = ({ closeDrawer, formState, data, handleUpdate, loading, rfpListData }) => {
    const { firstName, lastName, email, userName, status, securityLevel, oriRfpGroups } = formState[0]
    const [selectedUser] = useState(() => deepClone(formState[0]));
    const [edited, setEdited] = useState(false);
    const [isError, setIsError] = useState(false);
    const removedOriRfp = useUserManagementStore(state => state.removedOriRfp)
    const setRemovedOriRfp = useUserManagementStore(state => state.setRemovedOriRfp)
    const userConfig = useUserStore(state => state.userConfig)

    const oriRfpContainerRef = useRef<any>(null);
    const [oriRfpContainerHeight, setOriRfpContainerHeight] = useState<any>(0);
    const [resizing, setResizing] = useState(false)
    const [emailError, setEmailError] = useState(false)

    const validateEmail = useCallback((value: string) => {
        const emailPattern =
            /^(?!\.)(?!.*\.\.)(?!.*\.@)[A-Za-z0-9!#$%&'*+\-/=?^_`{|}~.]{1,64}@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;

        setEmailError(!emailPattern.test(value))

    }, [emailError])

    useEffect(() => {
        const handleResize = () => {
            const oriRfpContainerHeight = document.getElementById("oriRfpContainer")?.offsetHeight

            console.log('debug resize detected in handleResize: ', { oriRfpContainerRef, height: oriRfpContainerRef.current.getBoundingClientRect().height, oriRfpContainerHeight })

            setResizing(false)

            setOriRfpContainerHeight(2000)

            if (oriRfpContainerRef.current) {
                setOriRfpContainerHeight(oriRfpContainerRef.current.getBoundingClientRect().height);
            }

        }

        if (resizing) handleResize()
    }, [resizing])

    useEffect(() => {

        if (oriRfpContainerRef.current) {
            setOriRfpContainerHeight(oriRfpContainerRef.current.getBoundingClientRect().height);
        }

        const resizeEvent = () => {
            setResizing(true)
        }

        window.addEventListener('resize', resizeEvent);
        return () => {
            window.removeEventListener('resize', resizeEvent);
        };
    }, []);

    useEffect(() => {
        console.log('debug manage oriRfpGroups isEdited useEffect: ', { data, oriRfpGroups })
        const assignedGroups = data.oriRfpGroups
        console.log('debug manage oriRfpGroups isEdited useEffect assignedGroups: ', { oriRfpGroups, oriRfpAssigned: oriRfpGroups.filter(group => (group["rfp"] || group["secondaryOri"])?.hasOwnProperty("assigned")), assignedGroups })

        const isEdited = Object.keys(formState[0]).some((key) => {
            console.log('debug manage oriRfpGroups: ', { oriRfpGroups, key })
            if (key === "oriRfpGroups") {
                if (oriRfpGroups.filter(group => (group["rfp"] || group["secondaryOri"])?.hasOwnProperty("assigned")).length < assignedGroups.length && !oriRfpGroups.some(group => group.hasOwnProperty("new"))) {
                    console.log('debug manage oriRfpGroups isEdited useEffect assigned group removed')
                    return true
                } else if (oriRfpGroups.some(group => group.hasOwnProperty("new"))) {
                    console.log('debug manage oriRfpGroups isEdited useEffect new ori rfp field added')
                    return oriRfpGroups.every(group => {
                        if (group.hasOwnProperty("primaryOri")) {
                            return group.primaryOri.value.length > 1 && group.rfp.value.length > 1
                        } else if (group.hasOwnProperty("secondaryOri")) {
                            return group.secondaryOri.value.length > 1 && group.rfp.value.length > 1

                        }

                    })

                } else {
                    return oriRfpGroups.some((group: any, index: number) => {
                        console.log('debug manage oriRfpGroups isEdited useEffect')
                        return (
                            group.primaryOri?.value !== selectedUser[key][index]?.primaryOri?.value ||
                            group.rfp?.value !== selectedUser[key][index]?.rfp?.value ||
                            group.secondaryOri?.value !== selectedUser[key][index]?.secondaryOri?.value
                        );
                    })
                }

            } else {
                return key === "user" ?
                    JSON.stringify(selectedUser?.[key]) !== JSON.stringify(formState[0][key])
                    : selectedUser?.[key] !== formState[0][key];
            }
        });

        if (isEdited) {
            console.log('debug manage oriRfpGroups set edited true')
            setEdited(true);
        } else {
            console.log('debug manage oriRfpGroups set edited false')

            setEdited(false)
        }


    }, [formState, oriRfpGroups, removedOriRfp, data]);


    console.log(`debug securityLevel: `, { formState, securityLevel })
    const dispatchFormValues = formState[1]
    const tableConfig = useTableStore(state => state.tableConfig);

    const { config } = tableConfig["user-management"];
    const userRoles = config.cognito.userRoles

    const rfpOptions = JSON.parse(rfpListData ? rfpListData : '{}')

    const editUserTextField = {
        width: "268px"
    }

    const oriRfpField = {
        width: "100%"
    }

    const sectionHeader = { fontWeight: "500", minWidth: "108px", height: "25px", fontSize: "16px", lineHeight: "25.12px", letter: "0.1px" }

    const cancelEdit = useCallback(() => {
        console.log('debug manage oriRfpGroups cancel button pressed: ', { removedOriRfp })
        closeDrawer()
        setEmailError(false)

        dispatchFormValues({ type: EditUserAction.REMOVE_EMPTY_ORI_RFP_GROUP })
        if (removedOriRfp.length > 0) {
            dispatchFormValues({ type: EditUserAction.RESET_ORI_RFP_GROUP, removedOriRfp })
            setRemovedOriRfp([])
        }
    }, [removedOriRfp])

    const CustomPaper = (props: any) => {
        return <Paper {...props} sx={{ backgroundColor: 'background.default' }} />
    }

    const oriRfpContainer = document.getElementById("oriRfpContainer")


    console.log('debug securityLevel userConfig: ', userConfig)
    console.log('debug manage oriRfpGroups  ', oriRfpGroups)
    return (
        <Container disableGutters sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Container disableGutters sx={{ display: "flex", flexDirection: "column", width: "100%", height: !isError && !emailError ? "292px" : "325px", justifyContent: "space-evenly" }}>
                <Typography sx={sectionHeader}>
                    User Information
                </Typography>
                <InputWrapper customWidth="552px">
                    <TextField
                        label="First Name"
                        name="firstName"
                        value={firstName}
                        placeholder="First Name"
                        variant="outlined"
                        error={!firstName && isError}
                        helperText={!firstName && isError ? "First Name Field Cannot Be Empty" : ""}
                        sx={editUserTextField}
                        data-testid="first-name-text-field"
                        onChange={(e: any) => {
                            if (e.target.value === "") {
                                setIsError(true)
                            } else {
                                setIsError(false);
                            }
                            dispatchFormValues({ type: EditUserAction.FIRST_NAME, value: e.target.value })
                        }
                        } />
                    <TextField
                        label="Last Name"
                        name="lastName"
                        value={lastName}
                        error={!lastName && isError}
                        helperText={!lastName && isError ? "Last Name Field Cannot Be Empty" : ""}
                        placeholder="Last Name"
                        variant="outlined"
                        sx={editUserTextField}
                        data-testid="last-name-text-field"
                        onChange={(e: any) => {
                            if (e.target.value === "") {
                                setIsError(true)
                            } else {
                                setIsError(false);
                            }
                            dispatchFormValues({ type: EditUserAction.LAST_NAME, value: e.target.value })
                        }} />
                </InputWrapper>
                <InputWrapper customWidth="552px">
                    <TextField
                        disabled={true}
                        label="Username"
                        name="userName"
                        value={userName}
                        placeholder="Username"
                        variant="outlined"
                        sx={editUserTextField}
                        data-testid="username-text-field"
                        onChange={(e: any) => dispatchFormValues({ type: EditUserAction.USER_NAME, value: e.target.value })} />
                    <TextField
                        label="Email"
                        name="email"
                        value={email}
                        placeholder="Email"
                        variant="outlined"
                        sx={editUserTextField}
                        error={(!email && isError) || (emailError && edited)}
                        helperText={!email && isError ? "Email Field Cannot Be Empty" : emailError && edited ? "Invalid Email Format" : ""}
                        data-testid="email-text-field"
                        onChange={(e: any) => {
                            if (e.target.value === "") {
                                setIsError(true)
                            } else {
                                setIsError(false);
                            }
                            validateEmail(e.target.value)
                            dispatchFormValues({ type: EditUserAction.EMAIL, value: e.target.value })
                        }} />
                </InputWrapper>
                <InputWrapper customWidth="552px">
                    <FormControl>
                        <InputLabel color="secondary">Status</InputLabel>
                        <Select
                            value={status}
                            data-testid="status-select"
                            onChange={(e: any) => dispatchFormValues({ type: EditUserAction.STATUS, value: e.target.value })}
                            variant="outlined"
                            sx={editUserTextField}
                            label="Status">
                            <MenuItem value={"Active"}>Active</MenuItem>
                            <MenuItem value={"Inactive"}>Inactive</MenuItem>

                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel color="secondary">Security Level</InputLabel>
                        <Select
                            value={securityLevel}
                            data-testid="security-level-select"
                            onChange={(e: any) => dispatchFormValues({ type: EditUserAction.SECURITY_LEVEL, value: e.target.value })}
                            variant="outlined"
                            sx={editUserTextField}
                            label="Security Level">
                            {
                                userRoles.map((role: UserRole) => {
                                    console.log('debug securityLevel displaty role: ', role)
                                    return process.env.REACT_APP_LOWER_ENV === 'true'
                                        ? <MenuItem key={role.value} value={role.label}>{role.label}</MenuItem>

                                        : !role.devOnly //preprod and prod settings
                                            ? <MenuItem key={role.value} value={role.label}>{role.label}</MenuItem>
                                            : role.label === securityLevel && <MenuItem disabled key={role.value} value={role.label}>{role.label}</MenuItem>


                                })
                            }
                        </Select>
                    </FormControl>

                </InputWrapper>
            </Container>

            <Container disableGutters sx={{ flex: 2 }}>
                {
                    <Container disableGutters sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                        <Container disableGutters sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "552px" }}>
                            <Typography sx={sectionHeader}>
                                ORI's & RFP's
                            </Typography>
                            <AddUserOriRfp actionType={EditUserAction.ADD_ORI_RFP_GROUP} formState={formState} />
                        </Container>
                        <Container id="oriRfpContainer" ref={oriRfpContainerRef} disableGutters sx={{ flex: 2, width: "100%", overflowY: "auto", overflowX: "hidden", pt: "20px", pb: "20px", ...(!resizing && { maxHeight: oriRfpContainer?.hasChildNodes && oriRfpContainerHeight }) }}>
                            {
                                oriRfpGroups?.map((oriGroup, index) => {
                                    console.log('debug oriRfpGroups Edit group map: ', { oriGroup, index, oriRfpGroups })
                                    return (
                                        <InputWrapper customMarginTop="20px" customMargin="0px 0px 20px 0px" key={oriGroup.name} customWidth="552px">
                                            {
                                                Object.keys(oriGroup).map((key) => {
                                                    console.log('oriGroup[key].value', oriGroup[key])
                                                    if (key !== "new" && key !== "index") return (
                                                        <Box sx={{ width: "48%" }} key={`box-${oriGroup.name}-${key}`}>
                                                            {
                                                                key === "primaryOri" && (
                                                                    <TextField
                                                                        required
                                                                        disabled={oriGroup[key].assigned ? true : false}
                                                                        label={oriGroup[key].field}
                                                                        name={oriGroup[key].field}
                                                                        value={oriGroup[key].value}
                                                                        placeholder={oriGroup[key].placeholder}
                                                                        variant="outlined"
                                                                        sx={oriRfpField}
                                                                        error={!oriGroup[key].value && isError}
                                                                        helperText={!oriGroup[key].value && isError ? `Primary ORI field Cannot Be Empty ` : ""}
                                                                        data-testid={`${oriGroup[key].field.toLowerCase().replace(/ /g, '-')}-text-field`}
                                                                        onChange={(e: any) => {
                                                                            if (e.target.value === "") {
                                                                                setIsError(true)
                                                                            } else {
                                                                                setIsError(false);
                                                                            }
                                                                            dispatchFormValues({ type: EditUserAction.ORI_RFP_GROUP, value: e.target.value, group: { index, key } })
                                                                        }} />
                                                                )
                                                            }
                                                            {
                                                                key === "secondaryOri" && (
                                                                    <TextField
                                                                        disabled={oriGroup[key].assigned ? true : false}
                                                                        label={oriGroup[key].field}
                                                                        name={oriGroup[key].field}
                                                                        value={oriGroup[key].value}
                                                                        placeholder={oriGroup[key].placeholder}
                                                                        variant="outlined"
                                                                        sx={oriRfpField}
                                                                        error={!oriGroup[key].value && isError}
                                                                        helperText={!oriGroup[key].value && isError ? `Secondary ORI field Cannot Be Empty ` : ""}
                                                                        data-testid="secondary-ori-text-field"
                                                                        onChange={(e: any) => {
                                                                            if (e.target.value === "") {
                                                                                setIsError(true)
                                                                            } else {
                                                                                setIsError(false);
                                                                            }
                                                                            dispatchFormValues({ type: EditUserAction.ORI_RFP_GROUP, value: e.target.value, group: { index, key } })
                                                                        }} />
                                                                )
                                                            }
                                                            {
                                                                key === "rfp" && (
                                                                    <Autocomplete
                                                                        disabled={oriGroup[key].assigned ? true : false}
                                                                        id={`id-${key}`}
                                                                        sx={oriRfpField}
                                                                        options={rfpOptions}
                                                                        value={rfpOptions.find(option => option.rfp === oriGroup[key].value) || null}
                                                                        data-testid="rfp-autocomplete"
                                                                        PaperComponent={CustomPaper}
                                                                        getOptionLabel={(option: any) => option.rfp}
                                                                        ListboxProps={{ style: { maxHeight: "35vh" } }}
                                                                        renderOption={(props, option: any) => (
                                                                            <MenuItem
                                                                                {...props}
                                                                                key={option.code}
                                                                                sx={{
                                                                                    backgroundColor: 'background.default',
                                                                                    overflowY: 'auto',
                                                                                    wordWrap: 'break-word',
                                                                                    wordBreak: 'break-word',
                                                                                    whiteSpace: 'normal'
                                                                                }}
                                                                            >
                                                                                {option.rfp}
                                                                            </MenuItem>
                                                                        )}
                                                                        onChange={(e, newValue) => {
                                                                            if (!newValue) {
                                                                                setIsError(true)
                                                                            } else {
                                                                                setIsError(false);
                                                                            }
                                                                            dispatchFormValues({ type: EditUserAction.ORI_RFP_GROUP, value: newValue === null ? "" : newValue.rfp, group: { index, key } })
                                                                        }
                                                                        }
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                required={oriGroup[key].required}
                                                                                label="RFP"
                                                                                placeholder={oriGroup[key].placeholder}
                                                                                variant="outlined"
                                                                                error={oriGroup[key].value === "" && isError}
                                                                                helperText={oriGroup[key].value === "" && isError ? "RFP field cannot be empty" : ""}
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            {oriGroup.hasOwnProperty("new")
                                                                                                ?
                                                                                                <IconButton
                                                                                                    data-testid="remove-ori-rfp-group-icon-button"
                                                                                                    onClick={() => {
                                                                                                        dispatchFormValues({
                                                                                                            type: EditUserAction.REMOVE_ORI_RFP_GROUP,
                                                                                                            group: { index, key }
                                                                                                        })
                                                                                                    }
                                                                                                    }
                                                                                                    sx={{ zIndex: 5, position: "absolute", left: "91%", bottom: "87%", height: "28px", width: "28px" }}
                                                                                                    aria-label='Cancel'
                                                                                                >
                                                                                                    <CancelIcon color='primary' />
                                                                                                </IconButton>

                                                                                                : oriRfpGroups.filter(item => item[key].hasOwnProperty('assigned')).length > 1 &&
                                                                                                <IconButton
                                                                                                    aria-label='Remove Ori'
                                                                                                    data-testid="remove-ori-rfp-group-icon-button"
                                                                                                    onClick={() => {
                                                                                                        setRemovedOriRfp([...removedOriRfp, { removed: oriRfpGroups[index], index: oriRfpGroups[index].index }])

                                                                                                        dispatchFormValues({
                                                                                                            type: EditUserAction.REMOVE_ORI_RFP_GROUP,
                                                                                                            group: { index, key }
                                                                                                        })

                                                                                                        setEdited(true)
                                                                                                    }
                                                                                                    }
                                                                                                    sx={{ zIndex: 5, position: "absolute", left: "91%", bottom: "87%", height: "28px", width: "28px" }}
                                                                                                >
                                                                                                    <CancelIcon color='primary' />
                                                                                                </IconButton>

                                                                                            }
                                                                                            {params.InputProps.endAdornment}
                                                                                        </InputAdornment>
                                                                                    )
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                )
                                                            }
                                                            {
                                                            }
                                                        </Box>
                                                    )
                                                })

                                            }
                                        </InputWrapper>
                                    )
                                })
                            }
                        </Container>
                        <Container disableGutters sx={{ marginTop: "auto", display: "flex", width: "100%", height: "42px", justifyContent: "space-evenly" }}>
                            <Button data-testid="cancel-button" onClick={() => cancelEdit()} variant="outlined" sx={{ width: "268px" }}>CANCEL</Button>

                            <Button disabled={
                                !edited
                                    ? true
                                    : isError
                                        ? true
                                        : loading
                                            ? true
                                            : emailError
                                                ? true
                                                : false
                            }
                                onClick={() => {
                                    handleUpdate(formState)
                                }}
                                data-testid="update-button"
                                variant="contained"
                                sx={{ width: "268px" }}
                                aria-label='update'>
                                {loading ? <CircularProgress size='1.5rem' sx={{ color: 'secondary' }} /> : "UPDATE"}
                            </Button>
                        </Container>
                    </Container>
                }
            </Container>
        </Container>
    )
}